export default __webpack_public_path__ + "static/media/List-documentation.bf838149.md";